
import * as Wxlist from "@/services/constants";
import { GET_wx_userinfo,getShare } from "../services/index";
import wx from "weixin-js-sdk";

// 开始执行函数：
export const Start = (data)=>{
  console.log(123);
  if (JSON.stringify(data)!=='{}'){
    console.log(data);
    const { allowPcBrowser } = data;
    if (isWx()) {
      console.log('在微信');
      // 获取code
      wxcodeHandle(data);
    }else{
      if (allowPcBrowser===1) {
        console.log('可在PC');
      }else{
        return;
      }
    }
  }else{
    console.log(data);
  } 

}

function wxcodeHandle(data) {
  const {weixinUrl,wXIdentificationType,companID} =data;
  let code = GETUrlKey('code');
  if (code) {
    // 换取微信信息
    GET_wx_userinfo(code,companID,wXIdentificationType).then(res=>{
      if (res.result) {
        const {openid} = res.data
        localStorage.setItem(Wxlist.ZH_WX_OPENID,openid);
      }else{
        console.log('获取openid失败');
        jumpWx(weixinUrl,wXIdentificationType);
      }
    })
  }else{
    // 跳到微信获取code
    jumpWx(weixinUrl,wXIdentificationType);
  }
}

// 获取url参数
export const GETUrlKey = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

// 判断是否为微信浏览器
export const isWx = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  // eslint-disable-next-line 
  return ua.match(/MicroMessenger/i) == "micromessenger" ? true : false;
};

//跳往微信获取code:
export const jumpWx = (weixinUrl,wXIdentificationType) => {
  let scope
  switch (wXIdentificationType) {
    case 1:
      scope = 'snsapi_base'
      break;
    default:
      scope = 'snsapi_userinfo'
      break;
  }

  var wxUrl = weixinUrl.replace("$$REDIRECT_URI$$", Wxlist.URL).replace("$$SCOPE$$", scope).replace("$$STATE$$", Wxlist.STATE);
  window.location.replace(wxUrl);
};

// 微信分享：
export const setWxshare = (baseInfo) => {
  const { companyID } = baseInfo;
  let url = window.location.href.split('#')[0];
  getShare(companyID, url).then((res) => {
    console.log(res);
    if (res) {
      const { appId, nonceStr, signature, timestamp } = res;

      wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          "showMenuItems",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
        ],
      });
      wx.showMenuItems({
        menuList: [
          "menuItem:share:appMessage",
          "menuItem:share:timeline",
          "menuItem:favorite",
        ],
      });
      wx.ready(function () {
        wx.onMenuShareAppMessage({
          title: "中化国际-投资者服务",
          desc: "",
          imgUrl: "http://app1.a2china.cn/zhonghua/2021/InvestorService/wechat.jpg",
          link: Wxlist.URL,
          type: "link",
          dataUrl: "",
          success: function () {},
        });
        wx.onMenuShareTimeline({
          title: "中化国际-投资者服务",
          imgUrl: "http://app1.a2china.cn/zhonghua/2021/InvestorService/wechat.jpg",
          link: Wxlist.URL,
          success: function () {
            // 用户确认分享后执行的回调函数
          },
        });
      });
    }
  });
};


